import React from 'react';
import ReactDOM from 'react-dom';
import Screen from '../ui/Screen';
const screenRoot = document.getElementById('screen-root') || document.body;
export const createScreen = (options) => {


  const {
    closable = false,
    is_modal = false,
    component,
    title = "",
    offset = [0, 0],
    callback = () => { },
    signal = {},
    target = null
  } = options

  const div = document.createElement('div');

  const mountPoint = target || screenRoot;
  mountPoint.appendChild(div);

    // Root-like behavior, always

  if (target) {
    div.style.position = "fixed";
    div.style.top = "0";
    div.style.left = "0px";
    div.style.width = "100vw";
    div.style.height = "100vh";
    div.style.zIndex = "1";
  }




  const closeScreen = (e) => {
    callback(e);
    if (mountPoint.contains(div)) {
      ReactDOM.unmountComponentAtNode(div);
      mountPoint.removeChild(div);

    }
  };
  ReactDOM.render(<Screen is_modal={is_modal} offset={offset} signal={signal} closable={closable} title={title} callback={closeScreen} component={component} />, div);
};
